import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../../query/types';

const storeItemStudentFeesKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'student_fees'] as const;
  return createQueryKey({
    all: [...key] as const,
    id: <U extends QueryKeyParam>(uuid: U) =>
      createQueryKey({
        all: [...key, uuid] as const,
        detail: [...key, uuid, 'detail'] as const,
      }),
  });
};

export { storeItemStudentFeesKeys };
